import { FC } from 'react';
import classnames from 'classnames';
import { TagPicker, TagPickerProps } from 'rsuite';
// import { RsSelectSize, sizeMap } from './size';
import styles from './select.module.scss';

interface RsMultiSelectProps {
  groupBy: TagPickerProps['groupBy'];
  data: TagPickerProps['data'];
  value: TagPickerProps['value'];
  onChange: TagPickerProps['onChange'];
  className?: TagPickerProps['className'];
  disabled?: TagPickerProps['disabled'];
  loading?: TagPickerProps['loading'];
  placement?: TagPickerProps['placement'];
  renderMenuGroup?: TagPickerProps['renderMenuGroup'];
}

export const RsMultiSelect: FC<RsMultiSelectProps> = ({
  data = [],
  groupBy = '',
  value = [],
  onChange = () => undefined,
  className = '',
  disabled = false,
  loading = false,
  placement = 'bottomStart',
  renderMenuGroup = (groupByValue) => groupByValue,
}) => {
  return (
    <TagPicker
      groupBy={groupBy}
      data={data}
      value={value}
      onChange={onChange}
      className={classnames(styles.RsMultiSelect, className)}
      disabled={disabled}
      loading={loading}
      placement={placement}
      renderMenuGroup={renderMenuGroup}
    />
  );
};
